import { useState } from 'react'

import { BottomSheet, Button, Text } from 'components/InterUI/InterUI'
import bannerRepurchase from 'assets/png/banner_repurchase.png'
import useBoundState from 'store'

import * as S from './RedeemValue.styles'
import {
  analyticsRepurchaseBottomSheetDisplay,
  analyticsBSAcceptTag,
  analyticsBSDismissTag,
} from './RedeemValue.tags'

interface Props {
  show: boolean
  onClose: () => void
  onAccept: () => void
  onDismiss: () => void
}

export const RepurchaseBottomSheet = ({ show, onClose, onAccept, onDismiss }: Props) => {
  const monitoring = useBoundState((state) => state.monitoring)
  const [isLoading, setIsLoading] = useState(false)

  if (!show) {
    return null
  }
  analyticsRepurchaseBottomSheetDisplay()

  const handleAccept = () => {
    setIsLoading(true)
    onAccept()
    analyticsBSAcceptTag()
    monitoring({
      eventName: 'click_bottom_sheet_accept_button',
      params: {},
    })
  }

  const handleDismiss = () => {
    setIsLoading(true)
    onDismiss()
    analyticsBSDismissTag()
    monitoring({
      eventName: 'click_bottom_sheet_dismiss_button',
      params: {},
    })
  }

  return (
    <BottomSheet onClose={onClose}>
      <S.RepurchaseContent data-testid="repurchase-bottom-sheet">
        <S.RepurchaseBanner src={bannerRepurchase} alt="Banner de chance de recompra" />

        <Text variant="headline-h2" as="h2" semiBold>
          Oportunidade pra você!
        </Text>

        <Text variant="body-3" colorWeight={400}>
          Pague apenas metade do valor pra continuar nos 16 sorteios de R$ 7.000,00 por mais 12
          meses.
        </Text>

        <S.RepurchaseButtons>
          <Button
            data-testid="accept-repurchase-button"
            variant="primary"
            fullWidth
            onClick={handleAccept}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Aproveitar
          </Button>

          <Button
            data-testid="decline-repurchase-button"
            variant="secondary"
            fullWidth
            onClick={handleDismiss}
            isLoading={isLoading}
            disabled={isLoading}
          >
            Continuar com o resgate
          </Button>
        </S.RepurchaseButtons>
      </S.RepurchaseContent>
    </BottomSheet>
  )
}
